import styled from '@emotion/styled';

export const TitleBar = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});
